import { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./ServiceStart.css";
import serviceStartBg from "../assets/service-start-bg.gif";

const API_URL = process.env.REACT_APP_API_URL;

// Fixed target robot - matches ROBOT_SN already declared in the
// Android app's MiddlewareApi.java. This page always addresses this
// one robot; it isn't a fleet-wide action.
const ROBOT_SN ="M03SHW2A26026010YB02";
// "M03SHW2A26026010YB02 , MC1BHW2K10025021MAE5";

function navigateEndpoint(robotSn) {

    return `${API_URL}/portal/robots/${encodeURIComponent(robotSn)}/commands/navigate`;

}

function ServiceStart() {

    const [sending, setSending] = useState(false);

    const handleStartService = async () => {

        setSending(true);

        try {

            const res = await fetch(navigateEndpoint(ROBOT_SN), {

                method: "POST",

                headers: { "Content-Type": "application/json" },

                body: JSON.stringify({ requested_by: "admin-ui",execute_mode:"system" })

            });

            if (!res.ok) {

                const body = await res.json().catch(() => ({}));

                throw new Error(body.detail || `Request failed with status ${res.status}`);

            }

            const data = await res.json();

            toast.success(`Robot instructed to head to ${data.target_pos_name}.`);

        } catch (err) {

            console.error("Failed to start service:", err);

            toast.error(err.message || "Could not start the service. Please try again.");

        } finally {

            setSending(false);

        }

    };

    return (

        <div
            className="service-start-page"
            style={{ backgroundImage: `url(${serviceStartBg})` }}
        >

            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                pauseOnHover
            />

            {/* Transparent hotspot, precisely centered over the
                "Start Service" pill that's baked into the GIF itself -
                the GIF supplies 100% of the visuals, this just makes
                that exact spot clickable. aria-label stands in for
                visible text, since there is none on this element. */}
            <button
                type="button"
                className="service-start-btn"
                onClick={handleStartService}
                disabled={sending}
                aria-label={sending ? "Starting service" : "Start Service"}
                title={sending ? "Starting..." : "Start Service"}
            />

        </div>

    );

}

export default ServiceStart;
